<ng-template
  #toolbarIconButton
  let-title="name"
  let-svgIcon="svgIcon"
  let-iconName="icon"
  let-actionName="actionName"
  let-ariaLabel="ariaLabel"
  let-state="state"
>
  <a
    href="#"
    class="app-toolbar"
    mat-icon-button
    [title]="title"
    type="button"
    (click)="executeAction(actionName, state, $event); $event.preventDefault()"
  >
    <mat-icon [svgIcon]="svgIcon" [attr.aria-hidden]="ariaLabel ? false : true"
              [attr.aria-label]="ariaLabel ? ariaLabel : null">{{ iconName }}
    </mat-icon>
  </a>
</ng-template>

<div class="app-navigation">
  <mat-sidenav-container style="flex: 1">
    <mat-sidenav-content>
      @if (screen.device === 'desktop') {
        @if (pageConfiguration().hideHeaderToolbar !== true) {
          <mat-toolbar
            color="primary"
            class="app-navigation-top"
          >
            <nav class="app-container">
              @if (isShowTopLeftToolbarIconButton('desktop')) {
                <ng-container
                  *ngTemplateOutlet="
                toolbarIconButton;
                context: pageConfiguration().topLeftToolbarIconButton
              "
                ></ng-container>
              }
              @if (!pageConfiguration().hideDesktopNavigationMenu) {
                @for (item of navItems(); track item) {
                  <button
                    mat-flat-button
                    color="primary"
                    disableRipple="true"
                    class="app-menu-button"
                    [routerLink]="[item.link]"
                    [routerLinkActive]="'active'"
                  >
                    {{ item.name }}
                  </button>
                }
              }
              <div
                class="flex-spacer"
                [ngClass]="{
              'flex-spacer-page-title': pageConfiguration().showMobilePageTitle
            }"
              ></div>
              @if (pageConfiguration().showMobilePageTitle) {
                <div class="app-page-title">{{ title.pageTitle }}</div>
                <div class="flex-spacer-page-title"></div>
              }
              @if (isShowTopRightToolbarIconButton('desktop')) {
                <ng-container
                  *ngTemplateOutlet="
                toolbarIconButton;
                context: pageConfiguration().topRightToolbarIconButton
              "
                ></ng-container>
              }
              @if (!pageConfiguration().hideDesktopAccountMenu) {
                <button
                  class="app-user"
                  mat-flat-button
                  color="primary"
                  disableRipple="true"
                  [matMenuTriggerFor]="userMenu"
                >
                  {{ user.email }}
                  <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
              }
              <mat-menu #userMenu="matMenu">
                <app-account></app-account>
              </mat-menu>
            </nav>
            @if (inProgress()) {
              <mat-progress-bar
                color="accent"
                mode="indeterminate"
                aria-label="Fortschritt beim Laden der Seite"
              >
              </mat-progress-bar>
            }
          </mat-toolbar>
        }
      }
      @if (screen.device === 'mobile') {
        @if (pageConfiguration().hideHeaderToolbar !== true) {
          <mat-toolbar
            color="primary"
            class="app-appbar-top"
          >
            @if (isShowTopLeftToolbarIconButton('mobile')) {
              <ng-container
                *ngTemplateOutlet="
              toolbarIconButton;
              context: pageConfiguration().topLeftToolbarIconButton
            "
              ></ng-container>
            }
            <div class="app-page-title">{{ title.pageTitle }}</div>
            <div class="app-buttons">
              @if (isShowTopRightToolbarIconButton('mobile')) {
                <ng-container
                  *ngTemplateOutlet="
                toolbarIconButton;
                context: pageConfiguration().topRightToolbarIconButton
              "
                ></ng-container>
              }
            </div>
            @if (inProgress()) {
              <mat-progress-bar
                color="accent"
                mode="indeterminate"
                aria-label="Fortschritt beim Laden der Seite"
              >
              </mat-progress-bar>
            }
          </mat-toolbar>
        }
      }

      <div
        class="app-sidenav-content"
        [ngClass]="{ zero_padding_bottom: !showMobileBottomNavbar(), 'no-app-header' : pageConfiguration().hideHeaderToolbar }"
      >
        <div
          class="app-container"
          [ngClass]="{
            'app-container-without-margins': pageConfiguration().useAppFullWidth,
            'app-container-desktop-full-width': pageConfiguration().useDesktopAppFullWidth && screen.device === 'desktop'
          }"
        >
          <ng-content></ng-content>
        </div>
      </div>

      @if (showMobileBottomNavbar()) {
        <mat-toolbar class="app-navigation-bottom">
          @if (navItems()) {
            <nav>
              @for (item of navItems(); track item) {
                <button
                  mat-icon-button
                  routerLinkActive="active"
                  [routerLink]="[item.link]"
                >
                  @if (item.badge) {
                    <span class="nav-badge">{{ item.badge }}</span>
                  }
                  @if (item.svgIcon) {
                    <mat-icon [svgIcon]="item.svgIcon"> {{ item.icon }}</mat-icon>
                  } @else {
                    <mat-icon>{{ item.icon }}</mat-icon>
                  }
                  <div>{{ item.name }}</div>
                </button>
              }
              <button
                mat-icon-button
                routerLinkActive="active"
                [routerLink]="'account'"
              >
                <mat-icon>person</mat-icon>
                <div>Konto</div>
              </button>
            </nav>
          } @else {
            <nav>
              <a
                mat-icon-button
                [attr.target]="screen.isStandalone ? '_blank' : null"
                href="https://www.swm.de/privatkunden/info/impressum.html"
              >
                <span class="wrapper">
                  <mat-icon>fingerprint</mat-icon>
                  <div>Impressum</div>
                </span>
              </a>
              <a
                mat-icon-button
                [attr.target]="screen.isStandalone ? '_blank' : null"
                href="https://www.swm.de/datenschutz/swm-more-kundenportal "
              >
                <span class="wrapper">
                  <mat-icon>lock</mat-icon>
                  <div>Datenschutz</div>
                </span>
              </a>
              <button mat-icon-button (click)="user.logout()">
                <mat-icon>exit_to_app</mat-icon>
                <div>Abmelden</div>
              </button>
            </nav>
          }
        </mat-toolbar>
      }
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
